import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import axios, { AxiosInstance } from 'axios';
import { axiosIns } from './axios.config';
import { attachApiErrorToastInterceptor } from '../utils/api-error-toast';

export const axiosTokenInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_RESTUARENT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosTokenInst);
axiosIns.interceptors.request.use((config) => {
  config.baseURL = process.env.REACT_APP_API_BASE_RESTUARENT_URL;
  return config;
});

export const restuarentService = async ({ pageParam, tagParam, itemParam, nameParam }: any) => {
  try {
    const response = await axiosTokenInst.get('/get-all', {
      params: {
        page_number: pageParam,
        tag_id: tagParam,
        items_per_page: itemParam,
        name: nameParam,
      },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const restuarentIdService = async (params: any) => {
  try {
    return await axiosTokenInst.get(`${params}`);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useRestuarentIdService = (params: any, enable: boolean) => {
  return useQuery({
    enabled: enable,
    queryKey: ['restuarentid-service', params],
    queryFn: () => restuarentIdService(params),
  });
};

export const useRestuarentList = (currentTag: number | null, itemsPerPage: number | null, inputValue: string) => {
  return useInfiniteQuery({
    queryKey: ['restaurant-list', currentTag ? currentTag : 'all', inputValue],
    queryFn: ({ pageParam }) =>
      restuarentService({
        pageParam,
        tagParam: currentTag,
        itemParam: itemsPerPage,
        nameParam: inputValue,
      }),
    getNextPageParam: (lastPage: any) => {
      if (lastPage.current_page < lastPage.total_pages) {
        return lastPage.current_page + 1;
      }
      return false;
    },
    initialPageParam: 1,
  });
};
